import * as Category from '../OspreyAnalytics/Categories'

// removed all persistence for now
export class CategoryManager {
  static getCategory = (host, id) => {
    return Category.apiOspreyGetCategory(host, id)
  }
}
